import axios from "axios";
import Cookies from 'js-cookie'

import { createAsyncThunk,createSlice } from "@reduxjs/toolkit";

import { getBaseUrl } from "../../service/apiUrl";
export const STATUSES = Object.freeze({
    IDLE : 'idle',
    ERROR:'error',
    LOADING: 'loading',
});

const getsingleUserSlice = createSlice({
    name: 'singleUser',
    initialState: {
        data:[],
        status : STATUSES.IDLE,
    },

    extraReducers: (builder) => {
        builder
        .addCase(fetchsingleUser.pending, (state, action) => {
            state.status = STATUSES.LOADING;
        })
        .addCase(fetchsingleUser.fulfilled, (state, action) => {
            state.data = action.payload;
            state.status = STATUSES.IDLE
        })
        .addCase(fetchsingleUser.rejected , (state,action) => {
            state.status = STATUSES.ERROR;
        })
    }
});

export const {setsingleUser , setStatus} = getsingleUserSlice.actions;
export default getsingleUserSlice.reducer;

export const fetchsingleUser = createAsyncThunk('/singleUserget/fetch', async() => {
    const token = Cookies.get("token");
    const baseUrl = getBaseUrl().replace(/\/+$/, "");
    const headers = {};
    if (token && token !== "undefined") {
        headers.Authorization = token;
        headers["x-xsrf-token"] = token;
    }
    const res = await axios.get(`${baseUrl}/singlesubscriber/${Cookies.get('id')}`, {
        headers
    });
    const singleUserData = res.data;
    return singleUserData.data;
})